<script>
import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(SplitText)

export default {
  name: "SidebarIntro",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    mapVisible: {},
  },
  watch: {
    mapVisible(newVal) {

      if (newVal === true) {
        this.$nextTick(() => {

        });
      }
    },
  },
  data() {
    return {
      selectedImage: null
    }
  },
  beforeMount() {
    this.getAvatar(this.formData.avatar);
    this.$emit('goBack', 0);
    gsap.set(this.$refs.button1, {
      y: 0,
      autoAlpha: 0
    });
    gsap.set(this.$refs.button2, {
      y: 0,
      autoAlpha: 0
    });
  },
  mounted() {
    gsap.set(this.$refs.button1, {
      y: 0,
      autoAlpha: 0,
      duration: 0.1
    });
    gsap.set(this.$refs.button2, {
      y: 0,
      autoAlpha: 0,
      duration: 0.1
    });
    gsap.set(this.$refs.smallPopup, {
      display: "flex",
      opacity: 1,
      duration: 0.5
    });

    this.initAnimation();

  },
  methods: {
    getAvatar(avatar) {
      this.selectedImage = require(`@/assets/img/avatare/${avatar}.webp`);
    },
    launchTimeStep1() {
      this.$emit('nextStep', 'launchTimeStep1');
    },
    eventStep1() {
      this.$emit('nextStep', 'eventStep1');
    },
    closeOverlay() {
      this.$emit('closeOverlay')
    },
    nextStep(data) {
      this.$emit('nextStep', data)
    },
    initAnimation() {
      gsap.set(this.$refs.avatarthumb, {
        autoAlpha: 0
      });
      var mySplitText = new SplitText(this.$refs.speechbubble_anim.children, {type: "words"});
      var splitTextTimeline = gsap.timeline();
      mySplitText.split({type: "chars, words", charsClass: "test++",})
      splitTextTimeline
          .from(this.$refs.popupHeroContainer, {
            x: -50,
            autoAlpha: 0,
          })
          .from(this.$refs.introcontent, {
            x: 50,
            autoAlpha: 0,
          })
          .from(mySplitText.chars, {
            duration: 0.6,
            // display:"none",
            visibility: "hidden",
            stagger: 0.016,
            onComplete: () => {
              gsap.to(('.avatarthumb'), {
                autoAlpha: 1,
              })
            }
          })
          .fromTo(this.$refs.button1, {
            y: 20,

            autoAlpha: 0
          }, {
            y: 0,
            delay: 0.5,
            autoAlpha: 1
          })
          .fromTo(this.$refs.button2, {
            y: 20,
            autoAlpha: 0
          }, {
            y: 0,
            autoAlpha: 1,
          })

      ;
    },
    resetWebSpecial() {
      this.$emit('reset');
    },

  }
}
</script>

<template>
  <div ref="smallPopup" id="sidebarpopup" class="popup overlay smallerpopup"
       data-model="">

    <div ref="popup_wrapper__smaller" class="popup_wrapper popup_wrapper__smaller">
               <span @click="closeOverlay" class="popup_closepopup closeoverlay">
<svg xmlns="http://www.w3.org/2000/svg" width="22.945" height="22.945" viewBox="0 0 22.945 22.945">
  <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
    <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)" fill="none" stroke="#fff"
          stroke-linecap="round" stroke-width="2"/>
    <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117" transform="translate(20.117 0) rotate(90)"
          fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
</span>
      <div class="popup_morecontrols">
        <div @click="resetWebSpecial">
          <div class="flex-wrapper">
            <img ref="" class="" :src="selectedImage"/>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 class="icon icon-tabler icons-tabler-outline icon-tabler-refresh">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"/>
              <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/>
            </svg>
          </div>
          {{ $t("general.shortcutAvatar") }}
        </div>
      </div>
      <div class="popup_content popup_content_right">
        <div style="display: flex; gap:10px; align-items: stretch;">
          <div ref="popupHeroContainer" class="herocontainer">
            <img @load="onImageLoad" src="@/assets/img/mann_ohneschatten_small.webp">
            <img @load="onImageLoad" src="@/assets/img/frau_ohneschatten_small.webp">
          </div>
          <div ref="popup_content_right_container" class="popup_content_right_container">
            <div ref="introcontent" class="form-content introcontent" style="translate: none; rotate: none; scale: none; transform: translate(0px, 0px); opacity: 1; visibility: inherit;">
              <div class="herowrapper">
                <img src="@/assets/img/female.png"/>
                <img src="@/assets/img/male.png"/>
              </div>
              <div ref="speechbubble_anim">
                <p class="speechbubble_anim avatarthumb_wrapper">Hi, {{ this.formData.firstName }}!
                  <img ref="avatarthumb" class="avatarthumb" :src="selectedImage"/></p>
                <p class="speechbubble_anim">{{ $t("sidebarIntro.speechbubble_anim") }}</p>
              </div>
            </div>
            <div ref="button1">
              <a @click="nextStep(1)" class="button nextstep getGuideStep"
                 href="#"><span>{{ $t("sidebarIntro.break_txt") }}</span><img
                  src="@/assets/img/arrow-right.svg"></a>
            </div>
            <div  ref="button2" class="hideonmobile">
              <a @click="nextStep('controlsexplained')" class="button nextstep takeabreakStep outline"
                 href="#"><span>{{ $t("general.help") }}</span><img
                  src="@/assets/img/arrow-right.svg"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>


.popup_wrapper__smaller {
  padding: 125px 125px 20px 50px !important;
  @media screen and (max-width:768px) {
    padding: 125px 125px 50px 50px !important;
  }
  @media screen and (max-width:640px) {
    padding: 125px 15px 50px !important;
    flex-direction: column-reverse !important;
  }
  @media screen and (max-width:480px) {
    padding: 95px 15px 50px !important;
    flex-direction: column-reverse !important;
  }
}

.hideonmobile {
  @media screen and (max-width:768px) {
    display: none !important;
  }
}

.herowrapper {
  display:none;
  @media screen and (max-width:640px) {
    position: absolute;
    display:flex;
    top: 0px;
    transform: translateY(-65%);
    left: 0px;
  }


}

.herocontainer {
  img {
    width: 400px !important;
    @media screen and (max-width: 1024px) {
      width: 250px !important;
    }
    @media screen and (max-height: 950px) {
      width: 250px !important;
    }
  }
  @media screen and (max-width:640px) {
    display:none;
  }
}

.popup_morecontrols {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  left: 35px;
  top: 35px;
  box-sizing: border-box;
  z-index: 2;
  gap: 60px;
  font-size: 18px;

  @media screen and (max-width:640px) {
    gap:30px;
    font-size:16px;
    position:relative;
    margin-top:25px;
    top: auto;
    left: auto;
  }

  .flex-wrapper {
    position:relative;
    svg {
      position:absolute;
      top:0px;
      right:0px;
      transform:translateY(-25%) translateX(5px);
      height:auto;
      padding: 2px;
      background: #015672;
      stroke: white;
      border-radius: 50%;
      width: 20px;
      box-sizing: border-box;
    }
  }

  > div {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor:pointer;
    transition:0.3s;
    line-height:1.2em;
    &:hover {
      transform:scale(1.1);
    }
    svg {

    }
  }

  img:not(.language) {
    width: 40px;
    height: auto;
    border: 2px solid #015672;
    border-radius: 50%;
  }

}


.popup_content_right {
  @media screen and (max-width:640px) {
    width:100%;
    > div {
      width:100%;
    }
  }
}
.popup_content_right_container {
  @media screen and (max-width:640px) {
    width:100%;
  }
}
</style>
